import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const pensionFundRoutesDictionary = moduleRouteDictionaryFactory(
  'pensionFunds',
  'pension-funds',
  {
    list: 'list',
    create: 'create',
    update: 'update/:id',
  },
);
